import styled, { withProps } from 'ui/styled';
import Icon from '@datashop/icon';

export const Wrapper = withProps<{ isDP360Collapsed: boolean }>(styled.div)`
  display: flex;
  flex: 1;
  flex-grow: 0;
  flex-shrink: 0;
  flex-direction: column;
  align-items: center;
  flex-grow: 0;
  flex-shrink: 0;
  width: 48px;
  max-width: 48px;
  padding: 0 8px;
  border-left: 1px solid ${({ theme }) => theme.datashop.palette.stone.main};
  @media only screen and (max-width: 1024px) {
    ${({ isDP360Collapsed }) =>
      isDP360Collapsed
        ? ``
        : `
      display: none;
    `}
  };
`;

export const Element = withProps<{ isSelected?: boolean }>(styled.div)`
	font-size: 20px !important;
	padding: 6px;
	margin: 8px 0;
	cursor: pointer;
	height: 32px;
	width: 32px;
	border-radius: 50%;
	background-color: ${props => (props.isSelected ? props.theme.datashop.palette.stone.light : '')};
  &:hover {
    background-color: ${props => props.theme.datashop.palette.stone.light};
  }
`;

export const AppIcon = styled(Icon)``;
